import { render, staticRenderFns } from "./AlbumResults.vue?vue&type=template&id=8c761ba0&"
import script from "./AlbumResults.vue?vue&type=script&lang=js&"
export * from "./AlbumResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports